module.exports = __webpack_public_path__ + "media/images/catalog-promo/promo1000-a19391ed535299c4c816cf606468cae6.jpg";